module.exports = __webpack_public_path__ + "assets/ShiftAngleDetailed.085b67a4aa91a17199a279c9524874a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/ShiftAngleDetailed.png
// module id = 559
// module chunks = 0